import React from 'react';

import {routes} from './routes';
import {Link} from '../../components/Link';

export const bottomText = (credential: string) => (
  <p>
    Remember your {credential}. <Link to={routes.login.index}>Log In</Link>
  </p>
);

export const ResendEmail = ({resend}: {resend: React.MouseEventHandler}) => {
  return (
    <p>
      Didn't receive an email? <Link onClick={resend}>Resend the email</Link>
    </p>
  );
};
